module.exports = __webpack_public_path__ + "img/mockup-phone.09f278b4.png";